<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;"  
        [homeState]="this.homeState"
        [bpState]="this.bpState" 
        [fpState]="this.fpState" 
        [cpState]="this.cpState"
        [disableDocuments]="true"
    >
        <div class="lending-method stack">
            <div id="question">
                <h1>{{this.questionText}}</h1>
            </div>
            <div class="detailsView">
                <a class="companyName">{{ this.displayData.RegisteredCompanyName }}</a>
                <a *ngIf="this.displayData.Address1">{{ this.displayData.Address1 }},</a>
                <a *ngIf="this.displayData.Address2">{{ this.displayData.Address2 }},</a>
                <a>{{ this.displayData.City }}, {{ this.displayData.State }}, {{ this.displayData.ZipCode }}</a>

                <div class="primaryBtns">
                    <div class="button-Confirm-search-wrapper">
                    <app-primary-button class="confirmButton"
                         [text]="'Confirm'" 
                         [clickEvent]="this.confirmClick.bind(this)">
                    </app-primary-button>
                </div>
                <div class="button-Confirm-search-wrapper">
                    <app-primary-button class="thisIsntMeButton"
                         [text]="this.thisIsntMe"
                         [clickEvent]="this.thisIsntMeClick.bind(this)">
                    </app-primary-button>
                </div>
                </div>
            </div>
        </div>
    </app-shell>
</div>